import { createRoot } from 'react-dom/client';
import { initializeApp } from 'firebase/app';
import { App } from './App';
import { ServiceFactory } from './services/firestore/ServiceFactory';
import firebaseConfigExp from './assets/json/firebaseConfigExp.json';
import firebaseConfigProd from './assets/json/firebaseConfigProd.json';
import { getAccount } from './model/Collapsed';

const container = document.getElementById('app');
const root = createRoot(container);
// const app = initializeApp(process.env.NODE_ENV === 'production' ? firebaseConfigProd : firebaseConfigExp);
// const app = initializeApp(firebaseConfigProd);
const app = initializeApp(firebaseConfigExp);
const params = window.location.pathname.split('/');
const searchParams = new URLSearchParams(window.location.search);
const autoRefresh = searchParams.has('auto_refresh') && JSON.parse(searchParams.get('auto_refresh'));
const accountParams = {};
if(params.length === 3) {
  accountParams.host = params[1];
  accountParams.token = params[2];
}
else if(params.length === 4) {
  accountParams.host = params[1];
  accountParams.id = params[2];
  accountParams.apiKey = params[3];
}
getAccount(accountParams).then(account => {
  accountParams.id = account.id;
  accountParams.name = account.name;
  const serviceFactory = new ServiceFactory(app, account.id);
  serviceFactory.getAccountService().get(account.id || '').then(accountData => {
    console.log('accountData', accountData);
    accountParams.modules = accountData?.modules || [];
    root.render(<App params={accountParams} autoRefresh={autoRefresh} serviceFactory={serviceFactory} />);
  });
});